export default {
    isPlanner() {
        const profiles = this.user.profiles || []
        return profiles.includes('planner')
    },

    isWLUser() {
        return !!this.user.company
    },

    isSocialLoginUser() {
        return !!this.user.socialLogin
    },

    plannerWithFamily() {
        return this.isPlanner && !!this.user.family
    },
}
